// eslint-disable-next-line import/no-anonymous-default-export
export const Brands = [
    { name: 'Animale', baseUrl: 'https://www.animale.com.br', vtexName: 'lojaanimale', backendName: 'ANIMALE' },
    { name: 'A.Brand', baseUrl: 'https://www.offpremium.com.br', vtexName: 'lojaabrand', backendName: 'ABRAND' },
    { name: 'Fábula', baseUrl: 'https://www.afabula.com.br', vtexName: 'lojafabula', backendName: 'FABULA' },
    { name: 'Farm', baseUrl: 'https://www.farmrio.com.br', vtexName: 'lojafarm', backendName: 'FARM' },
    //{ name:'Foxton', baseUrl:'https://www.foxtonbrasil.com.br', vtexName:'foxton', backendName: 'FOXTON' },
    { name: 'Maria Filó', baseUrl: 'https://www.mariafilo.com.br', vtexName: 'mariafilo', backendName: 'MARIA FILO' },
    { name: 'Cris Barros', baseUrl: 'https://www.crisbarros.com.br', vtexName: 'lojacrisbarros', backendName: 'CRIS BARROS' },
    { name: 'FYI', baseUrl: 'https://www.offpremium.com.br', vtexName: 'lojafyi', backendName: 'FYI' },
    {
        name: 'Off Premium', baseUrl: 'https://www.offpremium.com.br', vtexName: 'lojaoffpremium', backendName: 'OUTLET',
        brands: [
            { filterItemName: 'Animale', vtexName: 'lojaanimale', filterItemValue: 'animale' },
            { filterItemName: 'Farm', vtexName: 'lojafarm', filterItemValue: 'farm' },
            { filterItemName: 'Fábula', vtexName: 'lojafabula', filterItemValue: 'fabula' },
            { filterItemName: 'Maria Filó', vtexName: 'mariafilo', filterItemValue: 'mariafilo' },
        ]
    }
]